import { 
  collection, 
  getDocs, 
  updateDoc, 
  doc 
} from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * سكريبت لإصلاح بيانات تكلفة قطع الغيار في السجلات الموجودة
 * يقوم بتحديث الحسابات للتأكد من الاتساق
 */
export const fixPartsCostData = async () => {
  try {
    console.log('🔧 بدء إصلاح بيانات تكلفة قطع الغيار...');
    
    // جلب جميع سجلات الصيانة
    const maintenanceCollection = collection(db, 'maintenance');
    const snapshot = await getDocs(maintenanceCollection);
    
    let updatedCount = 0;
    let errorCount = 0;
    
    for (const docSnapshot of snapshot.docs) {
      try {
        const data = docSnapshot.data();
        const usedParts = data.usedParts || [];
        
        if (usedParts.length === 0) {
          continue; // تخطي السجلات بدون قطع غيار
        }
        
        // إعادة حساب تكلفة قطع الغيار
        let totalPartsCost = 0;
        let needsUpdate = false;
        
        const updatedParts = usedParts.map((part: any) => {
          const sellingPrice = Number(part.sellingPrice) || Number(part.price) || 0;
          const purchasePrice = Number(part.purchasePrice) || sellingPrice;
          const quantity = Number(part.quantity) || 0;
          
          // التأكد من وجود كلا السعرين
          if (!part.sellingPrice || !part.purchasePrice) {
            needsUpdate = true;
          }
          
          totalPartsCost += sellingPrice * quantity;
          
          return {
            ...part,
            sellingPrice: sellingPrice,
            purchasePrice: purchasePrice,
            quantity: quantity
          };
        });
        
        // حساب رسوم الصيانة الجديدة
        const initialCost = data.initialCost || 0;
        const finalCost = data.finalCost || initialCost;
        const newMaintenanceFee = Math.max(0, finalCost - totalPartsCost);
        
        // حساب حصة الفني الجديدة
        const paid = data.totalPaid || data.paid || 0;
        const newTechnicianShare = Math.max(0, paid - totalPartsCost);
        
        // تحديث السجل إذا لزم الأمر
        if (needsUpdate || 
            Math.abs((data.maintenanceFee || 0) - newMaintenanceFee) > 0.01 ||
            Math.abs((data.technicianShare || 0) - newTechnicianShare) > 0.01) {
          
          await updateDoc(doc(db, 'maintenance', docSnapshot.id), {
            usedParts: updatedParts,
            maintenanceFee: newMaintenanceFee,
            technicianShare: newTechnicianShare,
            partsCost: totalPartsCost,
            laborCost: newMaintenanceFee,
            updatedAt: new Date(),
            fixedAt: new Date(),
            fixedBy: 'parts-cost-fix-script'
          });
          
          updatedCount++;
          console.log(`✅ تم تحديث السجل: ${docSnapshot.id}`);
        }
        
      } catch (error) {
        errorCount++;
        console.error(`❌ خطأ في تحديث السجل ${docSnapshot.id}:`, error);
      }
    }
    
    console.log(`🎉 تم الانتهاء من الإصلاح:`);
    console.log(`   - تم تحديث: ${updatedCount} سجل`);
    console.log(`   - أخطاء: ${errorCount} سجل`);
    console.log(`   - إجمالي السجلات المفحوصة: ${snapshot.docs.length} سجل`);
    
    return {
      total: snapshot.docs.length,
      updated: updatedCount,
      errors: errorCount
    };
    
  } catch (error) {
    console.error('❌ خطأ في تشغيل سكريبت الإصلاح:', error);
    throw error;
  }
};

/**
 * التحقق من صحة بيانات قطع الغيار
 */
export const validatePartsCostData = async () => {
  try {
    console.log('🔍 بدء التحقق من صحة البيانات...');
    
    const maintenanceCollection = collection(db, 'maintenance');
    const snapshot = await getDocs(maintenanceCollection);
    
    let validCount = 0;
    let invalidCount = 0;
    const issues: string[] = [];
    
    for (const docSnapshot of snapshot.docs) {
      const data = docSnapshot.data();
      const usedParts = data.usedParts || [];
      
      if (usedParts.length === 0) {
        continue;
      }
      
      let hasIssues = false;
      
      for (const part of usedParts) {
        // التحقق من وجود الأسعار
        if (!part.sellingPrice && !part.purchasePrice) {
          issues.push(`السجل ${docSnapshot.id}: قطعة ${part.name} بدون أسعار`);
          hasIssues = true;
        }
        
        // التحقق من صحة الأسعار
        if ((part.sellingPrice && isNaN(Number(part.sellingPrice))) ||
            (part.purchasePrice && isNaN(Number(part.purchasePrice)))) {
          issues.push(`السجل ${docSnapshot.id}: أسعار غير صحيحة للقطعة ${part.name}`);
          hasIssues = true;
        }
        
        // التحقق من الكمية
        if (!part.quantity || part.quantity <= 0) {
          issues.push(`السجل ${docSnapshot.id}: كمية غير صحيحة للقطعة ${part.name}`);
          hasIssues = true;
        }
      }
      
      if (hasIssues) {
        invalidCount++;
      } else {
        validCount++;
      }
    }
    
    console.log(`📊 نتائج التحقق:`);
    console.log(`   - سجلات صحيحة: ${validCount}`);
    console.log(`   - سجلات تحتاج إصلاح: ${invalidCount}`);
    
    if (issues.length > 0) {
      console.log(`⚠️  المشاكل المكتشفة:`);
      issues.forEach(issue => console.log(`   - ${issue}`));
    }
    
    return {
      valid: validCount,
      invalid: invalidCount,
      issues: issues
    };
    
  } catch (error) {
    console.error('❌ خطأ في التحقق من البيانات:', error);
    throw error;
  }
};